import React from "react";
import ButtonArrow from "../components/ButtonArrow";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import AccomodationComponent from "../components/Accomodation";
import CarouselComponent from "../components/CarouselComponent";
// import { useHeader } from "../Contexts/HeaderContext";
import { API_URL } from "../Helpers/api";
import shuffleArray from "../Helpers/ShuffleArray";
import { Helmet } from "react-helmet";
import acomodationsImg from "../Images/has_hotel.webp"

const Accomodation = () => {
  // const { marginTop } = useHeader();
  const [accomodations, setAccomodations] = useState();

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/accomodation`, null, true))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setAccomodations(shuffledAdds);
        } else {
          console.warn("No acomodation adds found");
        }
      })
      .catch((err) => console.error(err.message));
  }, []);

  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Alojamiento en Bella Unión – Hoteles y Estancias Turísticas</title>
        <meta
          name="description"
          content="Encuentra alojamiento cómodo y acogedor en Bella Unión. Opciones para descansar y disfrutar de la tranquilidad en plena naturaleza."
        />
        <meta
          name="keywords"
          content="alojamiento Bella Unión, hospedaje Bella Unión, hoteles Bella Unión, cabañas Bella Unión, turismo Uruguay"
        />
        <link rel="canonical" href="https://bellaunion.uy/alojamientos" />
        <meta property="og:title" content="Alojamiento en Bella Unión – Hoteles y Estancias Turísticas" />
        <meta
          property="og:description"
          content="Encuentra alojamiento cómodo y acogedor en Bella Unión. Opciones para descansar y disfrutar de la tranquilidad en plena naturaleza."
        />
        <meta property="og:url" content="https://bellaunion.uy/alojamientos" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={acomodationsImg} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Alojamiento en Bella Unión – Hoteles y Estancias Turísticas" />
        <meta
          name="twitter:description"
          content="Encuentra alojamiento cómodo y acogedor en Bella Unión. Opciones para descansar y disfrutar de la tranquilidad en plena naturaleza."
        />
        <meta name="twitter:image" content={acomodationsImg} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Alojamiento</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container">
          <h2 className="text-center pt-5">Alojamiento en Bella Unión: Descanso y Confort para tu Viaje</h2>
          <p className="text-center">
            La región ofrece una amplia variedad de alojamientos diseñados para satisfacer distintos gustos y
            necesidades. Desde hoteles con todas las comodidades hasta experiencias más inmersivas en la
            naturaleza, aquí encontrarás el lugar ideal para tu estadía.
          </p>
          {accomodations?.length > 0 ? (
            <>
              {accomodations.map((accomodation, i) => (
                <div className="row g-0 py-5 justify-content-center" key={accomodation._id}>
                  <AccomodationComponent data={accomodation} index={i} />
                </div>
              ))}
            </>
          ) : (
            <p className="fs-2 fw-light text-center">No se encontraron alojamientos</p>
          )}
        </div>
      </div>
    </main>
  );
};

export default Accomodation;
